import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useToast } from '../common/Toast';
import { API_URL } from '../../config';
import './AuthPages.css';

function PhoneVerification() {
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [step, setStep] = useState('phone'); // 'phone' ou 'code'
  const [devOtp, setDevOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { accessToken, updateUser } = useAuth();
  const navigate = useNavigate();
  const addToast = useToast();

  const sendOTP = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${API_URL}/auth/send-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({ phone })
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.erreur);

      if (data._dev_otp) {
        setDevOtp(data._dev_otp);
      }

      setStep('code');
      addToast('Code OTP envoye !');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const verifyOTP = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${API_URL}/auth/verify-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({ phone, code })
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.erreur);

      updateUser(data.user);
      addToast('Telephone verifie avec succes !');
      navigate('/profil');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card glass-card">
        <h2>Verification telephone</h2>
        <p className="auth-subtitle">Verifiez votre numero pour plus de confiance</p>

        {error && <div className="auth-error">{error}</div>}

        {devOtp && (
          <div className="dev-banner">
            Mode dev - Code OTP : <strong>{devOtp}</strong>
          </div>
        )}

        {step === 'phone' ? (
          <form onSubmit={sendOTP}>
            <div className="form-group">
              <label>Numero de telephone</label>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="0555123456"
                required
              />
            </div>
            <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
              {loading ? 'Envoi...' : 'Envoyer le code'}
            </button>
          </form>
        ) : (
          <form onSubmit={verifyOTP}>
            <div className="form-group">
              <label>Code OTP (6 chiffres)</label>
              <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="123456"
                maxLength={6}
                className="otp-input"
                required
              />
            </div>
            <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
              {loading ? 'Verification...' : 'Verifier'}
            </button>
            <button type="button" className="btn btn-secondary btn-full" onClick={() => setStep('phone')}>
              Renvoyer le code
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default PhoneVerification;
